









import { Component, Prop, Vue } from 'nuxt-property-decorator'

@Component
export default class WishlistButton extends Vue {
  @Prop({ type: Boolean }) isInWishlist!: boolean
  @Prop({ type: Boolean }) loading!: boolean

  onClick (): void {
    this.$emit(`click:${this.isInWishlist ? 'remove' : 'add'}`)
  }
}
